import React from 'react';
import { Box } from '@chakra-ui/react';
import { StatusColors, StatusType } from '../../constants/statusColors';
import { useTranslation } from 'react-i18next';

interface StatusBoxProps {
  status: StatusType;
  label?: string;
}

const StatusBox: React.FC<StatusBoxProps> = ({ status, label }) => {
  const { t } = useTranslation();
  const displayLabel = label || t(status);

  return (
    <Box
      bg={StatusColors[status]}
      color="black"
      borderRadius="20px"
      px="10px"
      h="25px"
    >
      {displayLabel}
    </Box>
  );
};

export default StatusBox;
